import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../../modules/auth';
import {BaseWebservice} from '../../../shared/base/base.webservice';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MatChipInputEvent} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ProcessService} from '../../_services/process.service';
import {Router} from '@angular/router';
import Swal from "sweetalert2";


export interface Fruit {
    name: string;
}

@Component({
    selector: 'app-share',
    templateUrl: './share.component.html',
    styleUrls: ['./share.component.scss']
})

export class ShareComponent implements OnInit {
    @ViewChild('chipsInput') chipsInput: ElementRef<HTMLInputElement>;
    srcimage= "url('assets/media/bg/image.svg')"
    download_link = '#'
    plan: any;
    first_name=""
    constructor(
        private authService: AuthService,
        private _globalService:BaseWebservice,
        private processService: ProcessService,
        private _cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private router: Router

    ) {
        // this.processService.getWillDownloadUrl().subscribe(response => {
        //   if (response['success'] == true) {
        //     this.download_link = response['data']['url']
        //   }
        // })
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    ngOnInit(): void {

        this.processService.getUserDetails().subscribe(response => {
            if(response['success'] == true) {
                this.first_name = this.capitalizeFirstLetter(response['data'].first_name)
                this.plan = +response['data'].plan


            } else {
            }
        })


        this.processService.getWillDownloadUrl().subscribe(response => {

            if (response['success'] == true) {

                this.download_link = response['data']['url']
                this._cd.detectChanges()
            }
        })
    }

    getDownloadLink() {
        return this.download_link
    }


    endSession() {
        this.authService.logout()
        this._globalService.setDataAsdefault()
    }

    openMoreCharities(content) {
        this.modalService.open(content, {centered: true, windowClass: 'modal-rounded',}).result.then((result) => {
            // this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    addOnBlur = true;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    fruits: Fruit[] = [
    ];

    add(event: MatChipInputEvent): void {
        const value = (event.value || '').trim();



        // var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var validRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        if (!value.match(validRegex) && value.length>0){
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-left',
                iconColor: 'red',
                customClass: {
                    popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            })
            Toast.fire({
                icon: 'warning',
                title: 'Invalid Email'
            })

            return
        }



        // Add our fruit
        if (value) {
            this.fruits.push({name: value});
        }

        // Clear the input value
        event.input.value = '';
        this.chipsInput.nativeElement.value = undefined
    }

    remove(fruit: Fruit): void {
        const index = this.fruits.indexOf(fruit);

        if (index >= 0) {
            this.fruits.splice(index, 1);
        }
    }

    closeModal() {
        this.modalService.dismissAll()
    }

    invite() {


        if(this.fruits.length ==0){
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-left',
                iconColor: 'red',
                customClass: {
                    popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            })
            Toast.fire({
                icon: 'warning',
                title: 'Please add an Email to invite them to platform'
            })
            return
        }

        this.processService.sendInvite({
            first_name:this.first_name,
            recipients: this.fruits.map(v => v['name'])
        }).subscribe(res => {
            if(res['success']) {
                this.closeModal();

                Swal.fire(
                    'Invitation Successful !',
                    '',
                    'success'
                ).then(value => {
                    // this.router.navigate([`/`])
                    this.modalService.dismissAll()
                })


            }
        })
    }

    goToDashboard(){

        window.open(
            'https://www.wisernow.com.au', '_blank' /* */);

    }
}
